<template>
    <div id='details'>
        <!-- banner -->
        <img class="banner" src="../../assets/images/about/banner.png" alt="">

        <div class="type_area">
            <!-- 产品展示 -->
            <div class="details1">
                <!-- 标题 -->
                <div class="title">
                    <p class="top">{{detail.title}}</p>
                </div>

                <!-- 大图展示 -->
                <div class="bigimg">
                    <!-- el-carousel -->
                    <el-carousel :autoplay=false indicator-position='none' ref='carousel' id='el_carousel' @change="onChange">
                        <!-- el-carousel__container -->
                        <el-carousel-item>
                            <img :src="detail.litpic" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img :src="detail.picture" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img :src="detail.photograph" alt="">
                        </el-carousel-item>
                    </el-carousel>

                    <div class="show_num">{{shownum}}<span class="_span">/</span>{{totalnum}}</div>
                </div>
            </div>

            <div class="details2">
                <!-- 标题 -->

                <div class="text" v-html="detail.product_feature">
                </div>

            </div>

            <div class="details3">
                <!-- 标题 -->
                <div class="title">
                    <p class="top">Parameter</p>
                    <p class="bottom">/{{detail.title}}/</p>
                </div>

                <!-- 表格1 -->
                <div class="patameter" v-html="detail.specification"></div>
            </div>

            <div class="details4">
                <!-- 标题 -->
                <div class="title">
                    <p class="top">Number and accessory</p>
                    <p class="bottom">/{{detail.title}}/</p>
                </div>

                <div class="accessory" v-html="detail.parts_number"></div>

                <!-- 表格3 -->
                <div class="nonstandard" v-html="detail.nonstandard_numerical_equipment"></div>
            </div>

            <!-- 推荐产品 -->
            <div class="details5" >
                <!-- 标题 -->
                <div class="title">
                    <p class="top">Recommended product</p>
                </div>

                <!-- 推荐的产品 -->
                <div class='recommend slider3'>
                    <div class="slide"  v-for="(item,index) in recommend" :key='index' @click='skip(item.aid)' v-loading="loading">
                        <img :src='item.litpic' @click='skip(item.aid)'>
                        <p class="_text" @click='skip(item.aid)'>{{item.title}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>




<script>
import { constants } from 'crypto';
import { setTimeout } from 'timers';
import { copyFileSync } from 'fs';
export default {
    
    data(){
        return{
            // 左右滑动切换图片
            startX:0,
            moveEndX:0,
            X:0,

            // 左右滑动的的图片
            slideimgs:[],
            totalnum:3, // 总的图片数
            shownum:0, //当前的图片数

            detail:{},
            recommend:[],
            loading:true
        }
    },

    methods: {
        // 左右滑动切图片
        slide(){
            var _this=this
            // 左右滑动事件
            $("#el_carousel").on("touchstart", function (e) {
                _this.startX = e.originalEvent.changedTouches[0].pageX;
            });
            $("#el_carousel").on("touchend", function (e) {
                _this.moveEndX = e.originalEvent.changedTouches[0].pageX;
                _this.X = _this.moveEndX - _this.startX;
                if(_this.X>0){
                    // console.log('左滑')
                    _this.$refs.carousel.prev()
                }
                if(_this.X<0){
                    // console.log('右滑')
                    _this.$refs.carousel.next()
                }
            })
        },

        // 产品大图展示当前图片数
        onChange(e){
            this.shownum=e+1
        },

        // 初始化推荐产品轮播
        initial(){
            $('.slider3').bxSlider({
                slideWidth: 200, // 图片盒子宽度
                minSlides: 3, // 图片显示的最小张数
                maxSlides: 3, // 图片显示的最大张数
                moveSlides: 2, // 每次移动的张数
                // slideMargin: 10 // 图片的外边距
            });
            this.loading=false
        },


        // 推荐产品的跳转
        skip(e){
            this.$router.push({ path:'/details?id='+e });
            window.location.reload()
        },

        // 获取推荐产品
        get_product(){
            this.$http.get("/recommendProductList.php").then((res)=>{
                this.recommend = res.data.data;

                this.$nextTick(() =>{
                    // 初始化推荐产品轮播
                    this.initial();
                })
            })
        }
    },

    mounted() {
        this.$http.get("/api/productDetail.php?id="+this.$router.currentRoute.query.id).then((res)=>{
            this.detail = res.data.data[0];
            this.slide();
        });
        this.$http.get("/recommendProductList.php").then((res)=>{
            this.recommend = res.data.data;
            setTimeout(this.initial, 200);
        });
        console.log(this.recommend)
    },

}
</script>



<style scoped lang="less">
    #details{
        margin: 3rem 0 0;
        min-height: 45.5rem;

        .banner{
            width:100%;
        }

        // 标题
        .title{
            width:100%;
            margin: 1rem 0;
            p{
                text-align: center;
            }
            .top{
                font-size: 2rem;
                font-weight: bold;
            }
            .bottom{
                color:#ccc;
            }
        } 

        .details1{
            // border:1px solid green;
            margin-top: 1rem;
            display:flex;
            justify-content: center;
            flex-wrap: wrap;

            // 大图展示
            .bigimg{
                width:24rem;
                height:24rem;
                // border:1px solid #ccc;
                // background:rgba(0,0,0,.5);
                // 左右滑动
                .el-carousel{
                    .el-carousel__item{
                        height:100%;
                        display:flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            width:100%;
                            // border:1px solid #000;
                        }
                    }
                }

                // 显示数字
                .show_num{
                    display:inline-block;
                    width:66px;
                    height:30px;
                    background:rgba(0,0,0,.5);
                    color:#fff;
                    border-radius: 10px;
                    display:flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 1.5rem;
                    position: relative;
                    bottom: 4rem;
                    right:-18rem;
                    z-index: 999;
                    ._span{
                        margin:0 6px;
                    }
                }
            }
            
        }
        
        .details2{
            // border:1px solid hotpink;
            margin-top: 1rem;

            // 上面的内容
            .text,ul{
                // border:1px solid green;
                width:90%;
                margin: 0 auto;
                font-size: 14px;
                text-align: center;
            }

            // 下面的内容
            ul{
                width:80%;
                margin-top: 1rem;
                padding-left: 2rem;
                text-align: left;
            }
        }
        
        .details3{
            // border:1px solid #f60;
            margin-top: 1rem;
        }

        .details4{
            // border:1px solid rgb(10, 25, 230);
            margin-top: 1rem;
            overflow: auto;
        }
        .details4::-webkit-scrollbar{
            display:none;
            // 表格2
            .el-table{
                width:100%;
            }

            // 表格3
            .ivu-table-wrapper{
                margin-top: 1rem;
            }
        }

        .details5{
            // border:1px solid rgb(10, 230, 58);
            margin-top: 1rem;
            padding-bottom: 1rem;
            box-sizing: border-box;           
        }

        // 推荐产品文字 
        ._text{
            position: absolute;
            top: 6rem;
        }
    }
    li{
        text-align: left;
    }

</style>

<style lang="css">
    #details .details2 li {
        text-align: left;
    }
</style>

